import React from 'react';
// import { graphql } from 'gatsby';
import {
  useQuery,
  useMutation,
  // useSubscription
} from '@apollo/client';
import gql from 'graphql-tag';

// BUILD-TIME: by Gatsby query executed, useless to my needs currently
export const GatsbyQuery = graphql`
  {
    resultReturned {
      characters {
        id
        name
        votes
      }
    }
  }
`;

// RUN-TIME: by Apollo query executed.
const APOLLO_QUERY = gql`
  {
    characters {
      id
      name
      votes
    }
  }
`;

export const ALL_CHAR_QUERY = gql`
  query characters {
    characters(order_by: { id: asc }) {
      id
      name
    }
  }
`;
export const ALL_VOTES_SUBSCRIPTION = gql`
  subscription allVotes {
    CharacterDeathVotes: characters(order_by: { id: asc }) {
      label: name
      data: votes
    }
  }
`;
export const SUM_VOTES_SUBSCRIPTION = gql`
  subscription voteCount {
    characters_aggregate {
      aggregate {
        sum {
          votes
        }
      }
    }
  }
`;
// TODO: ADD_VOTE_MUTATION ALL_VOTES_SUBSCRIPTION
export const ADD_VOTE_MUTATION = gql`
  mutation updateVotes($id: Int!) {
    update_characters(where: { id: { _eq: $id } }, _inc: { votes: 1 }) {
      affected_rows
    }
  }
`;

export default ({ data: { resultReturned } }) => {
  const { loading, error, data } = useQuery(APOLLO_QUERY);
  // TODO: useMutation useSubscription
  const [updateVotes] = useMutation(ADD_VOTE_MUTATION);
  let input;

  return (
    <div
      style={{
        backgroundColor: 'blueViolet',
        padding: '3px',
      }}
    >
      <div style={{ color: 'white', height: '100%', width: '100%' }}>
        {loading && (
          <h3 style={{ color: 'white', height: '100%', width: '100%' }}>
            Loading...
          </h3>
        )}
        {error && (
          <h3 style={{ color: 'white', height: '100%', width: '100%' }}>
            Error: ${error.message}
          </h3>
        )}
      </div>
      <div>
        {/* <h3 style={{ color: 'white' }}>Gatsby data at build time will be faster, but may not show subscribed Hasura changes</h3>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          backgroundColor: 'blue',
          justifyContent: 'space-between',
        }}>
          {resultReturned && resultReturned.characters ? resultReturned.characters.map(e => {
            return (
              <div style={{ padding: '5px' }} key={e.id}>
                <button style={{ flex: 8, borderRadius: '3px', backgroundColor: 'darkViolet', color: 'white' }}><b>{e.name}</b></button>
                <button onClick={() => alert(JSON.stringify(e.votes))} style={{ flex: 1, borderRadius: '3px', backgroundColor: 'purple', color: 'white' }}><b>{e.votes}</b></button>
                <div>
                  <form
                    onSubmit={e => {
                      e.preventDefault();
                      updateVotes({ variables: { type: input.value } });
                      input.value = '';
                    }}
                  >
                    <input
                      ref={node => {
                        input = node;
                      }}
                    />
                    <button type="submit">Vote</button>
                  </form>
                </div>

              </div>
            )
          }
          ) : <div style={{
            padding: '10px',
          }}>Apollo not ready</div>}
        </div>
        <br /><br /> */}

        <h3 style={{ color: 'white' }}>
          Apollo data at run time (not as fast but likely real time with Hasura
          subscriptions){' '}
        </h3>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            backgroundColor: 'blue',
            justifyContent: 'space-between',
          }}
        >
          {data && data.characters ? (
            data.characters.map(e => {
              return (
                <div style={{ padding: '5px' }} key={e.id}>
                  <button
                    style={{
                      flex: 8,
                      borderRadius: '3px',
                      backgroundColor: 'darkViolet',
                      color: 'white',
                    }}
                  >
                    <b>{e.name}</b>
                  </button>
                  <button
                    onClick={() => alert(JSON.stringify(e.votes))}
                    style={{
                      flex: 1,
                      borderRadius: '3px',
                      backgroundColor: 'purple',
                      color: 'white',
                    }}
                  >
                    <b>{e.votes}</b>
                  </button>
                  <button
                    onClick={() => updateVotes(1)}
                    style={{
                      flex: 1,
                      borderRadius: '3px',
                      backgroundColor: 'purple',
                      color: 'white',
                    }}
                  >
                    <b>{e.votes}</b>
                  </button>
                </div>
              );
            })
          ) : (
            <div>Apollo not ready</div>
          )}
        </div>
      </div>
    </div>
  );
};
